import { graphql } from ':src/graphql';

export const organizationMatchesByOrganizationIdQuery = graphql(`
  query OrganizationMatchesByOrganizationIdQuery($matchStatusId: Int, $programId: String) {
    organizationMatchesByOrganizationId(matchStatusId: $matchStatusId, programId: $programId) {
      result {
        matchStatusId
        supervisor {
          id
          firstName
          lastName
          displayName
          smallAvatar
          supervisorProfile {
            supervisorBandwidthId
          }
          usersLicenses {
            license {
              id
              displayName
            }
            usState {
              abbreviation
            }
          }
        }
      }
    }
  }
`);

export const usersByOrganizationId = graphql(`
  query UsersByOrganizationId(
    $limit: Int!
    $offset: Int!
    $organizationId: Int!
    $filter: UsersByOrganizationIdQueryFilter
    $searchQuery: String
    $sortByMostRecentSession: Boolean
    $programId: String
    $usStateId: Int
    $isRemovedTab: Boolean!
    $supervisorType: SupervisorTypeFilter
  ) {
    usersByOrganizationId(
      limit: $limit
      offset: $offset
      organizationId: $organizationId
      filter: $filter
      searchQuery: $searchQuery
      sortByMostRecentSession: $sortByMostRecentSession
      programId: $programId
      usStateId: $usStateId
      supervisorType: $supervisorType
    ) {
      result {
        id
        actorId
        firstName
        legalFirstName: firstName(legal: true)
        lastName
        fullName
        mediumAvatar
        superviseeProfile {
          id
          superviseeTypeId
          license {
            id
            displayName
          }
          licensureUsState {
            id
            name
            abbreviation
          }
        }
        supervisorMatches(activeOnly: false) {
          id
          supervisorId
          matchStatusId
          supervisor {
            id
            displayName
            slug
            isInternalSupervisor
          }
        }
        organization @skip(if: $isRemovedTab) {
          id
          name
        }
        organizationUser(deletedForOrganizationId: $organizationId) {
          id
          userId
          workEmail
          billingCode
          matchEmailSentAt
          scheduledForRemovalOn
          deletedAt
          recentSession {
            id
            scheduledAt
          }
          upcomingSession {
            id
            scheduledAt
          }
          approvedBySupervisorAt
          organizationProgram {
            id
            name
          }
          completedSupervisionHours @skip(if: $isRemovedTab) {
            totalMinutes
          }
          unmatchSuperviseeReason @include(if: $isRemovedTab) {
            id
            name
          }
        }

        organizationSuperviseeOnboardingRequest @skip(if: $isRemovedTab) {
          usState {
            id
            name
            abbreviation
          }
          licenseCategory {
            id
            name
            displayName
            abbreviation
          }
        }
      }
      total
    }
  }
`);

export const organizationSuperviseeOnboardingOptionsQuery = graphql(`
  query OrganizationSuperviseeOnboardingOptionsQuery {
    usStates {
      id
      name
    }
    licenseCategories {
      id
      displayName
    }
    superviseeTypes {
      id
      name
      description
    }
  }
`);

export const internalSupervisorsForPickerQuery = graphql(`
  query InternalSupervisorsForPicker($limit: Int!, $offset: Int!) {
    organizationSupervisors(supervisorType: INTERNAL, limit: $limit, offset: $offset) {
      result {
        supervisor {
          id
          fullName
        }
      }
      total
    }
  }
`);

export const supervisorBandwidthsQuery = graphql(`
  query SupervisorBandwidths {
    supervisorBandwidths {
      id
      name
    }
  }
`);

export const organizationByOnboardingFormSlugQuery = graphql(`
  query OrganizationByOnboardingFormSlugQuery($onboardingFormSlug: String!) {
    organizationByOnboardingFormSlug(onboardingFormSlug: $onboardingFormSlug) {
      id
      name
      requiresProgramOnSuperviseeUpload
      licenseCategories {
        id
      }
      usStates {
        id
      }
    }
  }
`);

export const bouncedEmailsQuery = graphql(`
  query BouncedEmailsQuery(
    $limit: Int!
    $offset: Int!
    $searchQuery: String
    $organizationId: Int
  ) {
    bouncedEmails(
      limit: $limit
      offset: $offset
      searchQuery: $searchQuery
      organizationId: $organizationId
    ) {
      result {
        user {
          id
          fullName
          email
          organizationUser {
            id
            organization {
              id
              name
            }
          }
        }
        error
      }
      total
    }
  }
`);
